// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__2tzSZ","productName":"Table_productName__yrl0l"};